import { pickerOptions, pageSizes } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import { startDate } from '@/utils/filter';
import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';
import setUrl from '@/mixins/setUrl';

export default {
  name: 'purchase',
  components: { HisAutocompleteSuggestions },
  mixins: [pageSize, setUrl],
  data() {
    return {
      pickerOptions,
      pageSizes,
      options: [{
        value: -1,
        label: '全部',
      }, {
        value: 0,
        label: '采购入库',
      }, {
        value: 3,
        label: '商城一键入库',
      }, {
        value: 5,
        label: '调拨入库',
      }, {
        value: 4,
        label: '其他入库',
      }, {
        value: 2,
        label: '外购',
      }],
      options1: [{
        value: -2,
        label: '全部',
      }, {
        value: 1,
        label: '采购退货',
      }, {
        value: 6,
        label: '调拨出库',
      }, {
        value: 7,
        label: '报损出库',
      }, {
        value: 8,
        label: '其他出库',
      }],
      batchStatus: ['未确认', '已确认', '已退货', '已取消'],
      tableData: [],
      tableData1: [],
      query: {
        startTime: '',
        endTime: '',
        instockType: -1,
        drugName: '',
        currentPage: 1,
        pageSize: 20,
      },
      query1: {
        startTime: '',
        endTime: '',
        instockType: -2,
        drugName: '',
        currentPage: 1,
        pageSize: 20,
      },
      time: startDate(),
      time1: startDate(),
      total: 0,
      total1: 0,
      orderList: [], // 商城订单
      isShopDrugs: 0,
      activeName: 'first',
    };
  },
  methods: {
    // filter chang handle
    filterChange() {
      this.getList(1);
    },
    handleSizeChange(val) {
      this.getList(1);
    },
    handleCurrentChange(val) {
      this.query.currentPage = val;
      this.getList();
    },
    // filter chang handle
    filterChangeOut() {
      this.getListOut(1);
    },
    handleSizeChangeOut(val) {
      this.getListOut(1);
    },
    handleCurrentChangeOut(val) {
      this.query.currentPage = val;
      this.getListOut();
    },
    toDetail(model, item) {
      const query = {
        state: model,
      };
      if (model !== 'add') query.id = item.id;
      this.$router.push({ name: 'purchaseDetail', query });
    },
    toOutDetail(model, item) {
      const query = {
        state: model,
      };
      if (model !== 'add') query.id = item.id;
      this.$router.push({ name: 'purchaseRetreat', query });
    },
    toDetailDiff(item) {
      const instockTypeArr = [0, 2, 3, 4, 5];
      if (instockTypeArr.includes(item.instockType)) {
        this.$router.push({
          name: 'purchaseDetail',
          query: {
            id: item.id,
            state: 'detail',
          },
        });
      } else {
        this.$router.push({ name: 'retreatDetail', params: { id: item.id } });
      }
    },
    querySearch(str, cb) {
      this.isShopDrugs = 0;
      this.$api.drugControl.getDrugByName({ drugName: str }).then((res) => {
        if (Array.isArray(res) && res.length > 0) {
          cb(res);
        } else {
          cb([]);
        }
      });
    },
    searchHandle(e) {
      this.query.drugName = e;
      this.getList(1);
    },
    selectHandle(e) {
      this.query.drugName = e.drugName;
      this.isShopDrugs = e.isShopDrugs;
      this.getList(1);
    },
    querySearchOut(str, cb) {
      this.isShopDrugs = 0;
      this.$api.drugControl.getDrugByName({ drugName: str }).then((res) => {
        if (Array.isArray(res) && res.length > 0) {
          cb(res);
        } else {
          cb([]);
        }
      });
    },
    searchHandleOut(e) {
      this.query1.drugName = e;
      this.getListOut(1);
    },
    selectHandleOut(e) {
      this.query1.drugName = e.drugName;
      this.isShopDrugs = e.isShopDrugs;
      this.getListOut(1);
    },
    getList(type) {
      if (type === 1) {
        this.query.currentPage = 1;
      }
      this.queryChangeHandle();
      this.$api.drugControl.batchInstock({
        ...this.query,
        startTime: this.time ? this.time[0] : '',
        endTime: this.time ? this.time[1] : '',
      }).then((res) => {
        if (res.list) this.tableData = res.list;
        this.total = res.total;
      });
    },
    getListOut(type) {
      if (type === 1) {
        this.query1.currentPage = 1;
      }
      this.queryChangeHandle();
      this.$api.drugControl.batchInstock({
        ...this.query1,
        startTime: this.time1 ? this.time1[0] : '',
        endTime: this.time1 ? this.time1[1] : '',
      }).then((res) => {
        if (res.list) this.tableData1 = res.list;
        this.total1 = res.total;
      });
    },
    // 获取商城订单
    shopOrderToStorage() {
      this.$api.drugControl.shopOrderToStorage().then((res) => {
        this.orderList = res.orderList.slice(0, 2) || [];
      });
    },
    // 取消订单入库
    cancleShopOrder(id) {
      this.$api.drugControl.cancleShopOrder({ id }).then((res) => {
        this.shopOrderToStorage();
      });
    },
    // 跳转一键入库
    gotoAddShopDrugs(id) {
      const query = {
        state: 'addShop',
        id,
      };
      this.$router.push({ name: 'purchaseDetail', query });
    },
    getTypeStr(val) {
      const item = this.options.find(res => res.value == val);
      if (item) {
        return item.label;
      }
      return '';
    },
    getTypeStrOut(val) {
      const item = this.options1.find(res => res.value == val);
      if (item) {
        return item.label;
      }
      return '';
    },
    getStatusStr(val) {
      return this.batchStatus[val];
    },
    deleteItem(item) {
      this.$api.drugControl.cancelBatchInstock({
        id: item.id,
      }).then((res) => {
        this.$message({
          message: '取消成功！',
          type: 'success',
        });
        this.getList(1);
        this.getListOut(1);
      });
    },
    // 出库
    toRetreat() {
      this.$router.push({ name: 'purchaseRetreat', query: { state: 'add' } });
    },
    // 筛选触发事件
    queryChangeHandle() {
      this.setPath({
        time: this.time,
        time1: this.time1,
        currentPage: this.query.currentPage,
        instockType: this.query.instockType,
        drugName: this.query.drugName,
        activeName: this.activeName,
        currentPage1: this.query1.currentPage,
        instockType1: this.query1.instockType,
        drugName1: this.query1.drugName,
      });
    },
    // 通过url初始化筛选项
    initQuery() {
      const queryUrl = this.getPath();
      if (queryUrl.time) {
        this.time = queryUrl.time;
      }
      if (queryUrl.time1) {
        this.time1 = queryUrl.time1;
      }
      this.query.drugName = queryUrl.drugName ? queryUrl.drugName : '';
      this.query.currentPage = queryUrl.currentPage ? Number(queryUrl.currentPage) : 1;
      this.query.instockType = queryUrl.instockType ? Number(queryUrl.instockType) : -1;
      this.query1.drugName = queryUrl.drugName1 ? queryUrl.drugName1 : '';
      this.query1.currentPage = queryUrl.currentPage1 ? Number(queryUrl.currentPage1) : 1;
      this.query1.instockType = queryUrl.instockType1 ? Number(queryUrl.instockType1) : -2;
      this.activeName = queryUrl.activeName ? queryUrl.activeName : 'first';
      this.getList();
      this.getListOut();
    },
  },
  mounted() {
    this.initQuery();
    this.shopOrderToStorage();
  },
};
